<template>
  <v-container style="height: auto !important;">
    <v-data-table
        :headers="headers"
        :items="orders"
        class="elevation-1"
        :loading="(orders.length === 0 && isLoading)"
        loading-text="Loading... Please wait"
    >
      <template v-slot:top>
        <v-toolbar
            flat
        >
          <v-toolbar-title>Orders</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog
              v-model="dialog"
              max-width="500px"
          >
            <!--                      <template v-slot:activator="{ on, attrs }">-->
            <!--                        <v-btn-->
            <!--                            dark-->
            <!--                            class="mb-2"-->
            <!--                            v-bind="attrs"-->
            <!--                            v-on="on"-->
            <!--                            @click="resetForm"-->

            <!--                        >-->
            <!--                          New Product-->
            <!--                        </v-btn>-->
            <!--                      </template>-->
            <v-form ref="form"
                    v-model="valid"
                    lazy-validation
            >
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container style="height: auto !important;">
                    <v-row>
                      <v-col
                          md="4"
                          sm="6"
                          cols="12"
                      >
                        <v-text-field
                            disabled
                            v-model="editedOrder.product.title"
                            label="Product name"
                            :rules="titleRules"
                            required
                        ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                          sm="6"
                          md="4"
                      >
                        <v-text-field
                            v-model="editedOrder.full_name"
                            label="Full Name"
                            :rules="fullNameRules"
                            required
                        ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                          sm="6"
                          md="4"
                      >
                        <v-text-field
                            v-model="editedOrder.email"
                            label="Email"
                            :rules="emailRules"
                            required
                        ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                          sm="6"
                          md="4"
                      >
                        <v-text-field
                            v-model="editedOrder.phone_number"
                            label="Phone number"
                            :rules="phoneNumberRules"
                            required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>

                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                      color="blue darken-1"
                      text
                      @click="close"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                      color="blue darken-1"
                      text
                      @click="save"
                      :disabled="!valid"
                  >
                    Save
                  </v-btn>
                </v-card-actions>

              </v-card>
            </v-form>
          </v-dialog>
          <v-dialog v-model="dialogReject" max-width="500px">
            <v-card>
              <v-card-title class="headline">Are you sure you want to reject this Order?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeReject">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="rejectOrderConfirm">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogApprove" max-width="500px">
            <v-card>
              <v-card-title class="headline">Are you sure you want to approve this Order?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeApprove">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="approveOrderConfirm">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <!--        <v-icon-->
        <!--            small-->
        <!--            class="mr-2"-->
        <!--            @click="editItem(item)"-->
        <!--        >-->
        <!--          mdi-pencil-->
        <!--        </v-icon>-->
        <v-icon
            v-if="item.status === 'pending'"
            small
            class="mr-2"
            @click="approveOrder(item)"
        >
          mdi-check
        </v-icon>

        <v-icon
            v-if="item.status === 'pending'"
            small
            @click="rejectOrder(item)"
        >
          mdi-close
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn
            dark
            @click="initialize"
        >
          Reset
        </v-btn>
      </template>
    </v-data-table>

  </v-container>
</template>

<script>
import {saveProduct, updateProduct} from "@/shared/productsService";
// eslint-disable-next-line no-unused-vars
import {rejectOrders, fetchOrders, approveOrders} from "@/shared/orderService";
import * as moment from "moment";

export default {
  name: "orders",
  data: () => ({
    valid: false,
    dialog: false,
    dialogApprove: false,
    dialogReject: false,
    isLoading: true,
    headers: [
      {
        text: '#',
        value: 'id',
      },
      {text: 'Product Name', value: 'product.title'},
      {text: 'Full Name', value: 'full_name'},
      {text: 'Email', value: 'email'},
      {text: 'Phone Number', value: 'phone_number', sortable: false},
      {text: 'Creation Date', value: 'created_at'},
      {text: 'Status', value: 'status'},
      {text: 'Actions', value: 'actions', sortable: false},
    ],
    orders: [],
    editedIndex: -1,
    titleRules: [
      v => !!v || 'Name is required',
    ],
    phoneNumberRules: [
      v => !!v || 'Phone number is required',
    ],
    emailRules: [
      v => !!v || 'Email is required',
      v => /.+@.+\..+/.test(v) || 'Email must be valid',
    ],
    fullNameRules: [
      v => !!v || 'Name is required',
    ],
    editedOrder: {
      id: 0,
      product_id: 0,
      full_name: '',
      email: '',
      phone_number: '',
      product: {title: ''}
    },
    defaultOrder: {
      id: 0,
      product_id: 0,
      full_name: '',
      email: '',
      phone_number: '',
      product: {title: ''}
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New Order' : 'Edit Order'
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogReject(val) {
      val || this.closeReject()
    },
    dialogApprove(val) {
      val || this.closeApprove()
    },
  },

  async created() {
    await this.initialize()
  },

  methods: {
    changeRule() {
      this.imageRules = [
        v => !!v || 'Image is required',
      ];
    },
    async initialize() {
      var response = await fetchOrders();
      this.orders = response.data;
      if (this.orders.length === 0) {
        this.isLoading = false;
      }
      this.orders = response.data.map(order => {
        order.created_at = moment(order.created_at).format('YYYY/MM/DD HH:mm:ss');
        return order;
      });
    },

    editItem(item) {
      this.editedIndex = this.orders.indexOf(item)
      this.editedOrder = Object.assign({}, item)
      this.dialog = true
    },
    approveOrder(item) {
      this.editedIndex = this.orders.indexOf(item)
      this.editedOrder = Object.assign({}, item)
      this.dialogApprove = true
    },
    rejectOrder(item) {
      this.editedIndex = this.orders.indexOf(item)
      this.editedOrder = Object.assign({}, item)
      this.dialogReject = true
    },

    deleteItem(item) {
      this.editedIndex = this.orders.indexOf(item)
      this.editedOrder = Object.assign({}, item)
      this.dialogDelete = true
    },
    rejectOrderConfirm() {
      const editedIndex = this.editedIndex;
      rejectOrders(this.orders[editedIndex]).then(() => {
        this.orders[editedIndex].status = 'declined';
      });
      this.closeReject()
    },
    approveOrderConfirm() {
      // delete product
      const editedIndex = this.editedIndex;
      approveOrders(this.orders[editedIndex]).then(() => {
        this.orders[editedIndex].status = 'approved';
      });
      this.closeApprove()
    },


    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedOrder = Object.assign({}, this.defaultOrder)
        this.editedIndex = -1
      })
    },

    closeApprove() {
      this.dialogApprove = false
      this.$nextTick(() => {
        this.editedOrder = Object.assign({}, this.defaultOrder)
        this.editedIndex = -1
      })
    },
    closeReject() {
      this.dialogReject = false
      this.$nextTick(() => {
        this.editedOrder = Object.assign({}, this.defaultOrder)
        this.editedIndex = -1
      })
    },
    resetForm() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.editedOrder = {
        id: 0,
        title: '',
        description: '',
        image: null,
        price: 0,
      };
    },
    save() {
      const editedIndex = this.editedIndex;
      const editedProduct = this.editedOrder;
      let form_data = new FormData();
      for (var key in this.editedOrder) {
        form_data.append(key, this.editedOrder[key]);
      }

      if (this.editedIndex > -1) {
        // update
        if (form_data.get('image') == "null")
          form_data.delete('image');
        updateProduct(form_data).then(() => {
          Object.assign(this.orders[editedIndex], editedProduct)
          this.$refs.form.resetValidation();
          this.$refs.form.reset();
        });
      } else {
        // save
        if (this.$refs.form.validate()) {
          saveProduct(form_data).then(response => {
            this.orders.push(response.data)
            this.$refs.form.resetValidation();
            this.$refs.form.reset();
          });
        }
      }
      this.close()

    },
  }
  ,
}
</script>

<style scoped>

</style>
